// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SocialIcon_wrapper__mjFdt","icon":"SocialIcon_icon___ouFu"};